import ArgonBadge from 'component/Argon/ArgonBadge';

const StatusCell = ({ row }) => {
  const value = row.original;

  if (value.isPaid) {
    return < ArgonBadge variant="contained" color="success" size="xs"
      badgeContent="จ่ายแล้ว" container />;
  } else {
    return <ArgonBadge variant="contained" color="error" size="xs"
      badgeContent="รอการชำระ" container />;
  }
};

export default StatusCell;